import {Afu} from 'app/components/entities/afu/model';

export function isCmsAfu(protocol: Afu.Protocol): protocol is Afu.CmsProtocol {
  return ['panopto', 'yuja', 'kaltura', 'opencast'].includes(protocol);
}
